import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import About from '../Components/About/About';
import Blogs from '../Components/Blogs/Blogs';
import Contact from '../Components/Contact/Contact';
import DoctorsDetails from '../Components/DoctorsDetails/DoctorsDetails';
import ErrorPage from '../Components/ErrorPage/ErrorPage';
import Home from '../Components/Home/Home';
import LegalAidDetails from '../Components/LegalAidDetails/LegalAidDetails';
import Login from '../Components/Login/Login';
import MainHome from '../Components/MainHome/MainHome';
import MySkills from '../Components/MySkills/MySkills';
import Projects from '../Components/Project/Projects';
import Register from '../Components/Register/Register';
import YdbikeDetails from '../Components/YdbikeDetails/YdbikeDetails';
import NaturlBdDetails from '../Components/NaturalBdDetails/NaturlBdDetails';
import TravelDetails from '../Components/TravelDetails/TravelDetails';

const Router = () => {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <MainHome></MainHome>,
      children: [
        { path: '/', element: <Home></Home> },
        { path: 'home', element: <Home></Home> },
        { path: 'About', element: <About></About> },
        { path: 'Contact', element: <Contact></Contact> },
        { path: 'Skill', element: <MySkills></MySkills> },
        { path: 'Register', element: <Register></Register> },
        { path: 'blog', element: <Blogs></Blogs> },
        { path: 'Contact', element: <Contact></Contact> },
        { path: 'Project', element: <Projects></Projects> },
        { path: 'Login', element: <Login></Login> },
        { path: 'ydbike', element: <YdbikeDetails></YdbikeDetails> },
        { path: 'doctors', element: <DoctorsDetails></DoctorsDetails> },
        { path: 'legalAid', element: <LegalAidDetails></LegalAidDetails> },
        { path: 'naturalbd', element: <NaturlBdDetails></NaturlBdDetails> },
        { path: 'travelAgency', element: <TravelDetails></TravelDetails> },
      ],
    },
    { path: '*', element: <ErrorPage></ErrorPage> },
  ]);
  return (
    <div>
      <RouterProvider router={router}></RouterProvider>
    </div>
  );
};

export default Router;
